import { pickChartFilterQuery } from '@/utils/charts/filterQuery';

export const chartItemScopes = (item) => (item?.scope ? [item.scope].flat() : ['read_charts']);

export const salespersonPath = (adminId, name, query) => {
    const id = String(adminId || '').trim();
    rememberSalespersonName(id, name);
    return {
        path: `/charts/salespeople/${encodeURIComponent(id)}`,
        query: pickChartFilterQuery(query),
    };
};

const salespersonNames = new Map();

export const rememberSalespersonName = (adminId, name) => {
    const id = String(adminId || '').trim();
    const label = typeof name === 'string' ? name.trim() : '';
    if (!id || !label) {
        return;
    }
    salespersonNames.set(id, label);
};

export const rememberedSalespersonName = (adminId) =>
    salespersonNames.get(String(adminId || '').trim()) || '';

export const partnerPath = (partnerId, name, query) => {
    const id = String(partnerId || '').trim();
    rememberPartnerName(id, name);
    return {
        path: `/charts/partners/${encodeURIComponent(id)}`,
        query: pickChartFilterQuery(query),
    };
};

const partnerNames = new Map();

export const rememberPartnerName = (partnerId, name) => {
    const id = String(partnerId || '').trim();
    const label = typeof name === 'string' ? name.trim() : '';
    if (!id || !label) {
        return;
    }
    partnerNames.set(id, label);
};

export const rememberedPartnerName = (partnerId) =>
    partnerNames.get(String(partnerId || '').trim()) || '';
